const produtos_list = [
    {
        img: "taurine.jpg",
        name: "Taurine (30caps) - VitaFor",
        price: 49.88,
        parcelas: 2,
        type: "pre-treino",
        promo: true,
    },
    {
        img: "creatine.jpg",
        name: "Creatine Creapure 300g - Nutrify",
        price: 293.63,
        parcelas: 3,
        type: "pre-treino",
        promo: true,

    },
    {
        img: "horus.jpg",
        name: "Hórus (300g) - Max Titanium",
        price: 1745.88,
        parcelas: 12,
        type: "pre-treino",
        promo: false,
    },
    {
        img: "BCAA.jpg",
        name: "BCAA 2044mg (90caps) - IntegralMédica",
        price: 62.38,
        parcelas: 2,
        type: "pos-treino",
        promo: false,
    },
    {
        img: "wheypure.jpg",
        name: "Super Whey 100% Pure Refil 907g - ",
        price: 9.99,
        parcelas: 2,
        type: "pos-treino",
        promo: false,

    },
    {
        img: "whey3W.jpg",
        name: "Super Whey 3W 907g - Integral Médica",
        price: 224.88,
        parcelas: 3,
        type: "pos-treino",
        promo: true,
    },

    {
        img: "creatinatp.jpg",
        name: "Creatina ATP 300g",
        price: 124.88,
        parcelas: 2,
        type: "pre-treino",
        promo: true,
    },
    {
        img: "veganpro.jpg",
        name: "VeganPRO",
        price: 237.38,
        parcelas: 3,
        type: "pos-treino",
        promo: false,
    },
    {
        img: "2NR.jpg",
        name: "COMBO 2 Nuclear Rush",
        price: 149.75,
        parcelas: 3,
        type: "pre-treino",
        promo: false,

    },
    {
        img: "horus.jpg",
        name: "Hórus (300g) - Max Titanium",
        price: 1745.88,
        parcelas: 12,
        type: "other",
        promo: false,
    },
    {
        img: "BCAA.jpg",
        name: "BCAA 2044mg (90caps) - IntegralMédica",
        price: 62.38,
        parcelas: 2,
        type: "other",
        promo: true,
    },
    {
        img: "wheypure.jpg",
        name: "Super Whey 100% Pure Refil 907g - ",
        price: 9.99,
        parcelas: 2,
        type: "other",
        promo: true,

    },
    {
        img: "colagen.jpg",
        name: "Colagen (100caps) - Max Titanium",
        price: 37.38,
        parcelas: 2,
        type: "pos-treino",
        promo: true,
    },
    {
        img: "creatine.jpg",
        name: "Creatine Creapure 300g - Nutrify",
        price: 293.63,
        parcelas: 3,
        type: "other",
        promo: true,

    },
    {
        img: "whey_red.jpg",
        name: "Nutri Whey Protein Refil 1,8kg - IntegralMédica",
        price: 110.49,
        parcelas: 2,
        type: "other",
        promo: true,
    },
    {
        img: "horus.jpg",
        name: "Hórus (300g) - Max Titanium",
        price: 1745.88,
        parcelas: 12,
        type: "other",
        promo: true,
    },
    {
        img: "BCAA.jpg",
        name: "BCAA 2044mg (90caps) - IntegralMédica",
        price: 62.38,
        parcelas: 2,
        type: "other",
        promo: true,
    },
    {
        img: "wheypure.jpg",
        name: "Super Whey 100% Pure Refil 907g - ",
        price: 9.99,
        parcelas: 2,
        type: "other",
        promo: true,

    },
    {
        img: "power1.jpg",
        name: "Pasta de Amendoim 1,005kg - Power One ",
        price: 20.49,
        parcelas: 2,
        type: "other",
        promo: true,
    },
    {
        img: "whey3W.jpg",
        name: "Super Whey 3W 907g - Integral Médica",
        price: 224.88,
        parcelas: 3,
        type: "other",
        promo: true,
    },
    {
        img: "taurine.jpg",
        name: "Taurine (30caps) - VitaFor",
        price: 49.88,
        parcelas: 2,
        type: "other",
        promo: true,
    },
    {
        img: "wheypure.jpg",
        name: "Super Whey 100% Pure Refil 907g - ",
        price: 9.99,
        parcelas: 2,
        type: "other",
        promo: true,

    },
]


export default produtos_list;